module.exports = __webpack_public_path__ + "img/step-3.ec46f7c0.png";